// BD 后台角色权限管理接口
// 文档：bd_admin_role_api.md。基础路径 mall/bdAdminRole，所有接口需登录、免签名。
// userId 为 18 位字符串，全程按字符串处理（响应已由 JSONBig storeAsString 转字符串）。

// 1. 获取全部角色（下拉 + 角色管理列表）
export const roleList = function () {
  return this.$http('get', 'mall/bdAdminRole/role/list')
}

// 2. 修改角色是否可用 { id, available }
export const roleUpdateAvailable = function (params) {
  return this.$http('post', 'mall/bdAdminRole/role/updateAvailable', params)
}

// 3. 按角色搜索的用户列表（分页）{ roleType?, keyword?, pageIndex?, pageSize? }
export const userPage = function (params) {
  return this.$http('get', 'mall/bdAdminRole/user/page', params)
}

// 4. 给用户指定角色 { userId, roleType }（同一 userId 重复指派 = 改角色；禁用角色不可指派）
export const userAssignRole = function (params) {
  return this.$http('post', 'mall/bdAdminRole/user/assignRole', params)
}

// 5. 移除用户的角色（userId 走 query）
export const userRemoveRole = function (userId) {
  return this.$http('post', 'mall/bdAdminRole/user/removeRole?userId=' + userId)
}
